import { render } from "./FragmentLayout.vue?vue&type=template&id=4973e8ee"
import script from "./FragmentLayout.vue?vue&type=script&lang=js"
export * from "./FragmentLayout.vue?vue&type=script&lang=js"

import "./FragmentLayout.vue?vue&type=style&index=0&id=4973e8ee&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__